<template>
  <b-row v-if="user || artist">
    <b-col :class="heroClass">
      <div class="blurbg" :style="heroStyle">
      </div>

      <!--<h1 v-bind:class="{ 'donation': !isLoggedIn && !artist }">{{ getName }}</h1>-->
      <h1>{{ getName }}</h1>
      <img class="bg" :src="getHero">

      <!--<div v-bind:class="{ 'donation': !isLoggedIn && !artist }" class="avatar">-->
      <div class="avatar">
        <img :src="getAvatar">
      </div>

      <div class="follow" v-if="artist && !ownProfile && isLoggedIn">
          <b-button class="btn-decorated" @click="follow" v-if="!isFollowing">
            <font-awesome-icon icon="plus"/>
            &nbsp; follow
          </b-button>
          <b-button class="btn-decorated active" @click="unfollow" v-else>
            <font-awesome-icon icon="check"/>
            &nbsp; following
          </b-button>
      </div>

      <div class="donate" v-bind:style="{ left: isFollowing ? '14em' : '12em' }" v-if="artist && !ownProfile && isLoggedIn">
          <b-button class="btn-decorated" id="btnDonate">
            <div class="icon"><img src="/static/icons/donate.svg" alt="Donate" /></div>
            <span class="txt">
            <font-awesome-icon icon="dollar-sign"/>
            &nbsp; donate
            </span>
          </b-button>
          <Donate target="btnDonate" :artist="artist"></Donate>
      </div>

      <div class="infobox videos" v-if="artist && artist.video_count !== undefined">
        <div class="icon"><img src="/static/img/icon-video.png" alt="Videos" /></div>
        <div class="num">{{ artist.video_count }}</div>
        <div class="txt">Video{{ plural(artist.video_count) }}</div>
      </div>

      <div class="infobox followers" v-if="artist && artist.follower_count !== undefined">
        <div class="icon"><img src="/static/img/icon-followers.png" alt="Followers" /></div>
        <div class="num">{{ artist.follower_count }}</div>
        <div class="txt">Follower{{ plural(artist.follower_count) }}</div>
      </div>
    </b-col>
  </b-row>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .hero {
    position: relative;
    overflow: hidden;

    padding: 0;
    margin: 0 0 1em 0;

    .blurbg {
      width: 100%;
      display: none;
      z-index: -5;
      position: absolute;
      background-position: center;
      background-size: 200%;
      transform: scale(1.1);
      overflow: hidden;
      border: 1px solid black;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      filter: blur(5px);
    }

    h1 {
      margin: 0;
    }

    @include media-breakpoint-up(sm) {
      padding: 20px;

      .blurbg {
        display: block;
      }
    }

    img.bg {
      width: 100%;
      z-index: -2;
      min-height: 320px;
      max-height: 420px;
      object-fit: cover;
      @include media-breakpoint-down(sm) {
        min-height: 265px;
      }
      @include media-breakpoint-down(xs) {
        min-height: 190px;
      }
    }

    h1 {
      position: absolute;
      left: 10px;
      bottom: 10px;
      font-size: 1.5rem;
      color: $bluish-white;
      text-shadow: 2px 2px 0 #000;
      font-family: 'AvenirHeavy';
    }

    .avatar {
      position: absolute;
      left: 10px;
      bottom: 55px;

      img  {
        width: 64px;
        height: 64px;
        border-radius: 100%;
      }
    }

    .donate {
      font-family: 'AvenirHeavy';
      position: absolute;
      top: 60px;
      .btn {
          padding: 12px 22px;
        &:before {
          z-index: 0;
        }
        svg {
          transform: scale(.8);
        }
      }
      .txt {
        @include media-breakpoint-down(md) {
          display: none;
        }
      }
      .icon {
        display: none;
        @include media-breakpoint-down(md) {
          display: block;
          img {
            max-width: 18px;
            filter: invert(1);
          }
        }
      }
    }
    @include media-breakpoint-up(sm) {
      h1 {
        bottom: 40px;
        left: 50px;
        font-size: 2rem;
      }

      .avatar {
        left: 50px;
        bottom: 90px;

        img {
          width: 64px;
          height: 64px;
        }
      }

      .donate {
        top: 85px;
        left: 50px;
      }
    }
    @include media-breakpoint-down(xs) {
      h1 {
        bottom: 20px;
        left: 65px;
      }

      .avatar {
        left: 10px;
        bottom: 10px;

        img {
          width: 45px;
          height: 45px;
        }
      }
    }
    @include media-breakpoint-up(lg) {
      h1 {
        font-size: 3rem;
        bottom: 45px;
        &.donation {
          bottom: 110px;
        }
      }

      .avatar {
        bottom: 115px;

        &.donation {
          bottom: 185px;
        }

        img {
          width: 100px;
          height: 100px;
        }
      }

      .donate {
        top: auto;
        right: auto;
        left: 50px;
        bottom: 40px;
      }
    }

    &.artist {
      .follow {
        font-family: 'AvenirHeavy';
        position: absolute;
        top: 10px;
        right: 20px;

        /deep/ button {
          background-color: $darkish-pink;
          opacity: 0.9;
          color: $white;
          padding-left: 2em;
          padding-right: 2em;
          font-weight: bold;
          padding: 12px 22px;
        }
        @include media-breakpoint-down(sm) {
          top: 25px;
        }

        .active {
          background-color: $aqua-marine;

          &:before {
            border-color: $aqua-marine;
          }
        }
      }
      .donate {
        font-family: 'AvenirHeavy';
        position: absolute;
        top: 60px;
        right: 20px;
        margin-left: 25px;

        /deep/ #btnDonate {
          background-color: $white;
          opacity: 0.75;
          color: $black;
          font-weight: bold;
          padding-left: 2em;
          padding-right: 2em;
          padding: 12px 22px;

          &:before {
            border-color: $white;
          }
        }
        @include media-breakpoint-down(xs) {
          left: auto !important;
          top: 75px;
        }
      }
      .follow,
      .donate {
        svg {
          transform: scale(.8);
        }
      }
      @include media-breakpoint-up(sm) {
        h1 {
          bottom: 40px;
        }

        .avatar {
          bottom: 90px;

          img {
            width: 64px;
            height: 64px;
          }
        }

        .follow {
          top: 30px;
          right: 40px;
        }

        .donate {
          top: 85px;
          right: 40px;
          left: auto !important;
        }
      }
      @include media-breakpoint-up(lg) {
        h1 {
          bottom: 110px;
        }

        .avatar {
          bottom: 185px;

          img {
            width: 100px;
            height: 100px;
          }
        }

        .follow {
          top: auto;
          right: auto;
          left: 50px;
          bottom: 40px;
        }

        .donate {
          top: auto;
          right: auto;
          left: 14em !important;
          bottom: 40px;
          &.not-following {
            left: 12em;
          }
        }
      }
      @include media-breakpoint-down(sm) {
        .donate {
          top: 85px;
        }
      }
      @include media-breakpoint-down(xs) {
        h1 {
          left: 65px;
          bottom: 20px;
        }
        .avatar {
          bottom: 10px;
          img {
            width: 45px;
            height: 45px;
          }
        }
        .donate {
          top: 80px;
        }
      }
    }

    .infobox {
      position: absolute;
      bottom: 20px;
      background-color: rgba(13, 13, 13, 0.72);
      border-radius: 2px;
      /* height: 100px; */
      padding: 12px 25px 10px 5px;
      min-width: 150px;
      padding-left: 1em;
      display: none;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      overflow: hidden;

      &:before,
      &:after {
        content: '';
        position: absolute;
        border-radius: 50%;
      }

      &:before {
        width: 110px;
        height: 110px;
        right: 0;
        background: #d8d8d8;
        opacity: 0.07;
      }
      &:after {
        width: 45px;
        height: 45px;
        right: 32px;
        background: #d8d8d8;
        opacity: 0.21;
      }

      .num {
        font-size: 2rem;
        font-family: 'AvenirHeavy';
        line-height: 1.2;
        margin-bottom: 6px;
        border-bottom: 4px solid white;
      }
      .txt {
        font-family: 'AvenirHeavy';
        font-size: 0.9rem;
        @include media-breakpoint-down(md) {
          display: none;
        }
      }
      .icon {
        display: none;
        img {
          max-width: 18px;
          margin-right: 0.5em;
        }
        @include media-breakpoint-down(md) {
          display: block;
        }
      }
      @include media-breakpoint-down(md) {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 15px 9px 12px;
        min-width: auto;
        &:before,
        &:after {
          content: none;
        }
        .num {
          border: none;
          margin: 0 8px 0 0;
          font-size: 0.9em;
        }
        .txt {
          font-size: 0.8em;
        }
        &.videos {
          bottom: 20px;
          right: 40px;
        }
        &.followers {
          bottom: 70px;
          /* right: 40px; */
        }
      }
      @include media-breakpoint-down(xs) {
        left: 15px !important;
        right: auto !important;
        bottom: unset !important;
        top: 25px;
        padding: 0.2em 0.2em 0.2em 0.5em;
        &.videos {
          top: 65px;
        }
      }
    }

    @include media-breakpoint-up(sm) {
      .infobox {
        display: flex;
      }
    }

    @include media-breakpoint-down(md) {
      .btn {
        font-size: .9em;
        padding: 8px 12px !important;
      }
    }

    .videos {
      border-top: 4px solid $purply-pink;
      right: 13.5em;
    }

    .followers {
      border-top: 4px solid $aqua-marine;
      right: 40px;
    }

  }
</style>

<script>
import { mapGetters } from 'vuex'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Donate from '@/components/widgets/Donate'

import { profileHelpers } from '@/store/helpers'

import map from 'lodash/map'

const emptyImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII='

export default {
  name: 'ProfileHero',
  components: {
    FontAwesomeIcon,
    Donate
  },
  props: {
    user: Object,
    artist: Object
  },
  data () {
    return {
      isFollowing: false
    }
  },
  computed: {
    getHero () {
      if (this.artist) return this.artist.hero_image || emptyImage
      if (this.user) return this.heroImage(this.user)
      return null
    },
    getAvatar () {
      if (this.artist) return this.artist.avatar_image
      if (this.user) return this.avatarImage(this.user)
      return null
    },
    getName () {
      if (this.artist) return this.artist.name
      if (this.user) return this.displayName(this.user)
      return ''
    },
    heroClass () {
      let cls = ['hero']
      if (this.artist && !this.ownProfile) cls.push('artist')
      return cls
    },
    heroStyle () {
      return {
        'background-image': 'url(' + this.getHero + ')'
      }
    },
    ownProfile () {
      let current = this.$store.getters['profile/currentUser']
      if (this.user && this.user.id === current.id) return true
      if (this.artist && current.artist && this.artist.id === current.artist.id) return true
      return false
    },
    ...mapGetters('auth', ['isLoggedIn'])
  },
  created () {
    this.initComponent()
  },
  watch: {
    'artist': 'initComponent'
  },
  methods: {
    async follow () {
      if (!this.isLoggedIn) {
        this.$router.push({name: 'account-login', query: { next: this.$route.fullPath }})
        return
      }
      if (!this.artist || this.ownProfile || this.isFollowing) return
      await this.$store.dispatch('profile/followProfile', {id: this.artist.profile.id})
      this.initComponent()
    },
    async unfollow () {
      if (!this.isLoggedIn) {
        this.$router.push({name: 'account-login', query: { next: this.$route.fullPath }})
        return
      }
      if (!this.artist || this.ownProfile || !this.isFollowing) return
      await this.$store.dispatch('profile/unfollowProfile', {id: this.artist.profile.id})
      this.initComponent()
    },
    async initComponent () {
      if (!this.artist || this.ownProfile) return

      let followedIds = map(await this.$store.dispatch('profile/listFollowedArtists'), a => a.id)
      this.isFollowing = (followedIds.indexOf(this.artist.id) !== -1)
    },
    plural (n) {
      return (n === 1) ? '' : 's'
    },
    ...profileHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/ProfileHero.vue